module.exports = __webpack_public_path__ + "img/collection-weddingRingsStackingRings.f441f54.jpg";